import * as req from 'api/actions';
import * as c from './constant';

// Misc Fees
export const getMiscFeeSettingsFeesList = (payload, callback) =>
  req.list(
    c.GET_MISC_FEE_SETTINGS_FEES_LIST,
    '/api/v1/administrators/settings/miscellaneous_fees',
    payload,
    callback
  );

export const showMiscFeeSettingsFees = (id, payload, callback) =>
  req.item(
    c.SHOW_MISC_FEE_SETTINGS_FEES,
    `/api/v1/administrators/settings/miscellaneous_fees/${id}`,
    payload,
    callback
  );

export const createMiscFeeSettingsFees = (payload, callback) =>
  req.create(
    c.CREATE_MISC_FEE_SETTINGS_FEES,
    '/api/v1/administrators/settings/miscellaneous_fees',
    payload,
    callback
  );

export const updateMiscFeeSettingsFees = (id, payload, callback) =>
  req.update(
    c.UPDATE_MISC_FEE_SETTINGS_FEES,
    `/api/v1/administrators/settings/miscellaneous_fees/${id}`,
    payload,
    callback
  );

export const deleteMiscFeeSettingsFees = (id, payload, callback) =>
  req.remove(
    c.REMOVE_MISC_FEE_SETTINGS_FEES,
    `/api/v1/administrators/settings/miscellaneous_fees/${id}`,
    payload,
    callback
  );

// Office
export const getMiscFeeSettingsOfficeList = (payload, callback) =>
  req.list(
    c.GET_MISC_FEE_SETTINGS_OFFICES_LIST,
    '/api/v1/administrators/settings/offices',
    payload,
    callback
  );

export const showMiscFeeSettingsOffice = (id, payload, callback) =>
  req.item(
    c.SHOW_MISC_FEE_SETTINGS_OFFICE,
    `/api/v1/administrators/settings/offices/${id}`,
    payload,
    callback
  );

export const createMiscFeeSettingsOffice = (payload, callback) =>
  req.create(
    c.CREATE_MISC_FEE_SETTINGS_OFFICE,
    '/api/v1/administrators/settings/offices',
    payload,
    callback
  );

export const updateMiscFeeSettingsOffice = (id, payload, callback) =>
  req.update(
    c.UPDATE_MISC_FEE_SETTINGS_OFFICE,
    `/api/v1/administrators/settings/offices/${id}`,
    payload,
    callback
  );

export const deleteMiscFeeSettingsOffice = (id, payload, callback) =>
  req.remove(
    c.REMOVE_MISC_FEE_SETTINGS_OFFICE,
    `/api/v1/administrators/settings/offices/${id}`,
    payload,
    callback
  );

// others
export const getRoleList = (
  payload = { is_paginated: 1, sort_by: 'desc' },
  callback
) =>
  req.list(c.GET_ROLE_LIST, 'api/v1/administrators/roles', payload, callback);
